module.exports = __webpack_public_path__ + "img/2020_03-31-Sudbury-worship.1123bda9.jpg";